import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessInstanceSummary } from './process-instance-summary';
export { ProcessInstanceSummary };
import { processInstanceSummarySchema } from '@schemas/business-objects/process-instance-summary';
import { ProcessDesignFormGroup } from './process-design-form-group';
import { TenantFormGroup } from './tenant-form-group';

export class ProcessInstanceSummaryFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    referenceNumber: SchemaFormControl;
    name: SchemaFormControl;
    status: SchemaFormControl;
    data: SchemaFormControl;
    dataText: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidateEmail: SchemaFormControl;
    errorMessage: SchemaFormControl;
    processName: SchemaFormControl;
    processDisplayName: SchemaFormControl;
    processVersion: SchemaFormControl;
    designUuid: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    completedAt: SchemaFormControl;
    processDesignId: SchemaFormControl;
    processDesign: ProcessDesignFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<ProcessInstanceSummary>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processInstanceSummarySchema, ProcessInstanceSummary, data, options);
  }

  get object(): ProcessInstanceSummary {
    return new ProcessInstanceSummary(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'processDesign':
        return new ProcessDesignFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessInstanceSummary[]> {
    return ProcessInstanceSummary.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessInstanceSummary | null> {
    return ProcessInstanceSummary.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessInstanceSummary> {
    return ProcessInstanceSummary.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessInstanceSummary>,
  ): Promise<ProcessInstanceSummary> {
    return ProcessInstanceSummary.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessInstanceSummary>,
  ): Promise<ProcessInstanceSummary> {
    return ProcessInstanceSummary.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessInstanceSummary.deleteById(id);
  }
}

export class ProcessInstanceSummaryFormArray extends PersistedFormArray {
  declare controls: ProcessInstanceSummaryFormGroup[];

  readonly entityName = 'ProcessInstanceSummary' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processInstanceSummarySchema, ProcessInstanceSummary, options);
  }

  protected override createItemGroup() {
    return new ProcessInstanceSummaryFormGroup();
  }

  get array(): ProcessInstanceSummary[] {
    return this.controls.map(
      (group: ProcessInstanceSummaryFormGroup) => group.object,
    );
  }
}

export class ProcessInstanceSummaryPersistedArray extends PersistedArray<ProcessInstanceSummary> {
  readonly entityName = 'ProcessInstanceSummary' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessInstanceSummary, options);
  }
}
